export const VERSION_FETCH_COMPLETE = "Bundle version fetch complete";
export const VERSION_FETCH_BY_GAMSITE_ID = "Bundle version fetch complete by gamSiteId";
export const VERSION_UPDATED= "Bundle version updated";
export const VERSION_CONFIG_ADD= "Bundle version is added";

